import React from "react";

export default () => {
  return (
    <>
      <div className="container">
        Ada
      </div>
    </>
  );
};
